export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10408.941b61f5.jpg";